import { render } from "./PricingPlans.vue?vue&type=template&id=068487f0"
import script from "./PricingPlans.vue?vue&type=script&lang=js"
export * from "./PricingPlans.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__